import 'react-dates/initialize';
import 'react-dates/lib/css/_datepicker.css';
import { FC } from 'react';

import { ChevronDown, UpArrowIcon } from '@assets/icons';

import DateRangePicker, {
  DayPickerRangeControllerProps,
} from './DateRangePicker';
import { renderNavButton } from '../renderNavButton';
import { ResponsiveNavDownButton } from '../DatePickerStyle';

const ResponsiveDateRangePicker: FC<DayPickerRangeControllerProps> = (
  props
) => {
  return (
    <DateRangePicker
      orientation='verticalScrollable'
      numberOfMonths={12}
      renderNavPrevButton={renderNavButton(
        ResponsiveNavDownButton,
        UpArrowIcon,
        20,
        5
      )}
      renderNavNextButton={renderNavButton(
        ResponsiveNavDownButton,
        ChevronDown,
        20
      )}
      daySize={38}
      {...props}
    />
  );
};

export default ResponsiveDateRangePicker;
